import { render, staticRenderFns } from "./HeightPrediction.vue?vue&type=template&id=3d6b9a08&scoped=true&"
import script from "./HeightPrediction.vue?vue&type=script&lang=js&"
export * from "./HeightPrediction.vue?vue&type=script&lang=js&"
import style0 from "./HeightPrediction.vue?vue&type=style&index=0&id=3d6b9a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b9a08",
  null
  
)

export default component.exports